/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Color_GreenInputs */



/**
* | output |
* | --- |
* | "Green" |
*
* @param {Settings_Template_Color_GreenInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_color_green = /** @type {((inputs?: Settings_Template_Color_GreenInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Color_GreenInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Groen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vert")
	return /** @type {LocalizedString} */ ("Green")
});